<div class="filter-tag-container">
    @if(filters.length > 0){
    <span class="active-filter"> <mat-icon svgIcon="filter-icon" style="width: 16px; height: 16px;" />Active
        filters</span>
    }
    <div *ngFor="let filter of filters">

        <mat-chip-row>
            @if (filter.icon) {
            <mat-icon [svgIcon]="filter.icon" />
            }
            @else {
            <span style="width: 6px;"></span>
            }

            <span class="filter-label">{{filter.label }}</span>
            <button matChipRemove (click)="onRemoveTagClick(filter.type, filter.value)">
                <mat-icon>cancel</mat-icon>
            </button>
        </mat-chip-row>
    </div>
    @if(filters.length > 0){
    <span (click)="clearAll()" class="remove-all">Remove all filters</span>
    }
</div>